<template lang="html">
  <div class="terminal-list">
    <div class="breadCrumb-container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{$t('message.terminal')}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="terminal-header">
      <div class="title">
        <div class="import-container">
          <el-button v-if="queryFlag" class="verifone-btn upload" type="primary" plain icon="el-icon-upload2" @click="handleImport">{{$t('message.import')}}</el-button>
          <el-button v-else disabled class="verifone-btn upload" type="primary" plain icon="el-icon-upload2" @click="handleImport">{{$t('message.import')}}</el-button>
          <input v-show="false" type="file" class="addFileInput" ref="importInput" @change="handleFileInput">
        </div>
      </div>

      <div class="flex-row search-container">
        <form name="mapForm" class="map-container" action="/marketplace/terminal/map" target="_blank" method="get">
          <el-button v-if="queryFlag" class="verifone-btn map" type="submit" plain icon="el-icon-location" @click="handleMap">{{$t('message.map')}}</el-button>
          <input type="hidden" name="queryType" :value="queryType">
          <input type="hidden" name="queryInfo" :value="searchInput">
          <input type="hidden" name="acceptLanguage" v-model="acceptLanguage">
          <input type="hidden" name="queryPage" :value="syncCurrentPage">
          <div class="select-input-container">
            <el-input class="reachInput"
                      :placeholder="$t('message.enterKeyword')"
                      v-model="searchInput" @keyup.enter.native="querySearchList" clearable>
            </el-input>
            <el-select class="rearchSelect" v-model="queryType" :placeholder="$t('message.pleaseChoose')">
              <el-option v-for="item in queryOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </form>
        <el-button  class="search-btn" icon="el-icon-search" @click="querySearchList"></el-button>
        <el-button v-if="queryFlag" class="verifone-btn" type="primary" plain icon="el-icon-plus" @click="handleAdd">{{$t('message.add')}}</el-button>
        <el-button v-else disabled class="verifone-btn" type="primary" plain icon="el-icon-plus" @click="handleAdd">{{$t('message.add')}}</el-button>
      </div>
    </div>

    <div class="table-container verifone-panel">
      <div class="table-main btn-table">
        <template>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="sn" label="SN" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <div v-if="queryFlag" class="hrefStyle" @click="toTerminalEdit(scope.row)">{{scope.row.sn}}</div>
                <div v-else>{{scope.row.sn}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="deviceId" :label="$t('message.deviceId')" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="model" :label="$t('message.model')"></el-table-column>
            <el-table-column prop="merchantName" :label="$t('message.merchant')" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="status" :label="$t('message.status')" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1" class="green-icon"></span>
                <span v-if="scope.row.status == 0" class="red-icon"></span>
                <span v-if="scope.row.status == 0">{{scope.row.alertMsg}}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('message.operation')" width="220" align="center">
              <template slot-scope="scope">
                <el-button v-if="queryFlag" class="verifone-btn" type="info" plain icon="el-icon-document" @click="handleCopy(scope.row)">{{$t('message.copy')}}</el-button>
                <el-button v-else disabled class="verifone-btn" type="info" plain icon="el-icon-document" @click="handleCopy(scope.row)">{{$t('message.copy')}}</el-button>
                <el-button v-if="queryFlag" class="verifone-btn" type="danger" plain icon="el-icon-close" @click="handleDelete(scope.row)">{{$t('message.delete')}}</el-button>
                <el-button v-else disabled class="verifone-btn" type="danger" plain icon="el-icon-close" @click="handleDelete(scope.row)">{{$t('message.delete')}}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>

      <div class="pagination-main">
        <el-pagination  background layout="prev, pager, next" :current-page.sync="syncCurrentPage" :total="totalPage*10" @current-change="changePage"></el-pagination>
      </div>

    </div>

    <el-dialog title="" :visible.sync="addDialogVisible" width="30%" class="quit-dialog">
      <span><h4>Add Terminal</h4></span>
      <div class="sn-container">
        <span>SN</span>
        <el-input v-model="addSN"></el-input>
        <span class="required-add required-sn">*</span>
      </div>
      <div class="model-container">
        <span>Model</span>
        <el-input v-model="addModel"></el-input>
        <span class="required-add required-model">*</span>
      </div>
      <span slot="footer" class="dialog-footer">
                <el-button @click="addDialogVisible = false">Cancel</el-button>
                <el-button type="success" @click="callAdd">OK</el-button>
            </span>
    </el-dialog>

    <el-dialog title="" :visible.sync="deleteDialogVisible" custom-class="tips-dialog" class="quit-dialog warn-dialog">
      <div class="warn-container flex-row">
        <img class="warn-icon" alt="" src="static/img/alertWarn.png">
        <span>&nbsp;&nbsp;{{$t('message.warn')}}</span>
      </div>
      <div class="dialog-body">
        <span>{{$t('message.deleteTerminal')}}</span><span>{{taskName}}</span><span>"?</span>
      </div>

      <span slot="footer" class="dialog-footer">
				<el-button class="verifone-btn" type="primary" plain @click="deleteDialogVisible = false">{{$t('message.no')}}</el-button>
				<el-button class="verifone-btn" type="primary" @click="callDelete">{{$t('message.yes')}}</el-button>
			</span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        operateSn: '',
        syncCurrentPage: 1,
        totalPage: null,
        addSN: '',
        addModel: '',
        addDialogVisible: false,
        deleteDialogVisible: false,
        searchInput: '',
        searchHistory: '',
        queryFlag: false,
        tableData: [],
        multipleSelection: [],
        queryOptions: [{
          label: 'SN',
          value: 0
        },{
          label: this.$t('message.merchantName'),
          value: 1
        },{
          label: this.$t('message.groupName'),
          value: 2
        },{
          label: this.$t('message.parameter'),
          value: 3
        },{
          label: this.$t('message.deviceId'),
          value:4
        }
        ],
        queryType: 0,
        taskName: '',
        xmlCheck: this.$t('message.xmlCheck'),
        deleteSuccess: this.$t('message.deleteSuccess'),
        inputCheck: this.$t('message.inputCheck'),
        uploadSuccess: this.$t('message.uploadSuccess'),
        acceptLanguage:sessionStorage.getItem('acceptLanguage')
      }
    },
    mounted() {
      this.queryTerminalList(1);
      this.setQuery();
    },
    methods: {
      handleMap() {
        document.mapForm.submit();
      },
      setQuery() {
        let roleArr = sessionStorage.getItem('verifoneRoleList').split(',').map(str => parseInt(str));
        this.queryFlag = !roleArr.includes(41);
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      handleModify(row) {
        this.operateSN = row.sn;
        this.$router.replace('/terminalOperate/'+ row.terminalId + '/' + this.operateSN);
      },
      handleAdd() {
        this.$router.replace('/terminalAdd');
      },
      handleDelete(row) {
        this.taskName = row.sn;
        this.operateSn = row.sn;
        this.deleteDialogVisible = true;
      },
      handleCopy(row) {
        this.operateSN = row.sn;
        this.$router.replace('/copy/'+ this.operateSN);
      },
      handleImport() {
        this.$refs.importInput.click();
      },
      handleFileInput(e) {
        let files = e.target.files[0];
        let length = files.name.split('.').length;
        let fileSuffix = files.name.split('.')[length - 1];
        let reader = new FileReader();
        let that = this;

        console.log(fileSuffix);

        reader.readAsDataURL(files);
        reader.onload = function(e) {
          let mb = (e.total/1024)/1024;

          if(fileSuffix != 'xml' && fileSuffix != 'XML') {
            console.log('err');
            that.$message({
              type: "error",
              message: that.xmlCheck,
              duration:'3000',
            });
            return;
          }

          that.submitFile(this.result, fileSuffix);
        }
      },
      changePage(page) {
        this.syncCurrentPage = page;

        if(this.searchInput) {
          this.querySearchList(page);
        }else {
          this.queryTerminalList(page);
        }
      },
      submitFile(file, filePrefix) {
        let that = this,
          obj = {
            file: file,
            filePrefix: filePrefix
          };

        this.$axios({
          method: 'post',
          url: '/marketplace/terminal/import',
          headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            that.$message({
              type: "error",
              message: response.data.desc,
              duration:'3000',
            });
            return;
          }else {

            that.$message({
              type: "success",
              message: this.uploadSuccess,
              duration:'3000',
            });

            that.syncCurrentPage = 1;
            that.queryTerminalList(1);//?查询需确定
          }
        }).catch((err) => {
          console.log(err);
        });

        this.$refs.importInput.value = null;
      },
      callAdd() {
        let that = this,
          obj = {
            sn: this.addSN,
            model: this.addModel
          };

        if(this.addSN == '' || this.addModel == '') {
          this.$message({
            type: "error",
            message: this.inputCheck,
            duration:'3000',
          });

          return;
        }

        this.$axios({
          method: 'post',
          url: '/marketplace/terminal/add',
          headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            that.$message({
              type: "error",
              message: response.data.desc,
              duration:'3000',
            });
            return;
          }else {
            that.addDialogVisible = false;
            that.syncCurrentPage = 1;
            that.queryTerminalList(1);
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      queryTerminalList(page) {
        let that = this,
          obj = {
            pageNum: page
          };

        this.$axios({
          method: 'post',
          url: '/marketplace/terminal/page',
          headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            that.$message({
              type: "error",
              message: response.data.desc,
              duration:'3000',
            });
            return;
          }else {
            that.totalPage = response.data.totalPage;
            that.tableData = response.data.terminalList;
            that.syncCurrentPage = page;
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      callDelete() {
        let that = this,
          obj = {
            sn: this.operateSn
          };

        this.$axios({
          method: 'post',
          url: '/marketplace/terminal/delete',
          headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            that.$message({
              type: "error",
              message: response.data.desc,
              duration:'3000',
            });
            return;
          }else {
            that.$message({
              type: "success",
              message: this.deleteSuccess,
              duration:'3000',
            });
            that.deleteDialogVisible = false;
            that.queryTerminalList(that.syncCurrentPage);
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      querySearchList() {
        let that = this,
          obj = {
            queryType: this.queryType,
            queryInfo: this.searchInput,
            pageNum: 1
          };

        if(this.searchInput == '') {
          this.syncCurrentPage = 1;
          this.searchHistory = '';
          this.queryTerminalList(1);
          return;
        }

        //new query => refresh page
        if(this.searchInput != this.searchHistory) {
          this.syncCurrentPage = 1;
        }else {
          obj.pageNum = this.syncCurrentPage;

        }

        this.$axios({
          method: 'post',
          url: '/marketplace/terminal/search',
          headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
          data: obj
        }).then(response => {
          if (response.data.resultCode != 0) {
            that.$message({
              type: "error",
              message: response.data.desc,
              duration:'3000',
            });
            return;
          }else {
            that.totalPage = response.data.totalPage;
            that.tableData = response.data.terminalList;
          }

          this.searchHistory = this.searchInput;
        }).catch((err) => {
          console.log(err);
        });
      },

      toTerminalEdit(row) {
        this.operateSN = row.sn;
        this.$router.replace('/terminalOperate/'+ row.terminalId + '/' + this.operateSN);
      }
    }

  }
</script>

<style scoped="scoped">
  .table-container {
    background-color: #fff;
    position: relative;
  }
  .search-add, .terminal-select, .search-main, .terminal-search-container {
    display: flex;
    display: -webkit-display;
    flex-direction: row;
    justify-content: flex-end;
  }
  .table-main {
    padding: 20px;
  }
  .pagination-main {
    padding: 10px 0;
  }
  .createBtn-main {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    position: absolute;
    right: 0;
    bottom: 10px;
    align-items: center;
    padding-right: 10px;
  }
  .load-selector {
    background-color: #53bfb7!important;
    color: #fff!important;
    padding: 10px 15px;
    margin: 0 3px 0 20px;
  }
  .arrows-right {
    width: 25px;
    height: 25px;
    transform: rotate(180deg);
    position: relative;
    bottom: -7px;
  }
  .num-container {
    font-size: 15px;
    color: #666;
  }
  .el-icon-close {
    font-size: 20px;
    font-weight: 800;
    color: red;
  }
  .delete-btn {
    width: 20px;
    height: 20px;
  }
  .edit-btn {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    color: #00a0e8;
    cursor: pointer;
    justify-content: center;
  }
  .edit-right {
    width: 20px;
    height: 20px;
    margin-left: 5px;
  }
  .el-table td, .el-table th {
    padding: 9px 0;
  }
  .terminal-header {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 56px;
    line-height: 56px;
  }
  .title {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: flex-start;
  }
  .sn-container, .model-container {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    padding: 5px 0;
    position: relative;
  }
  .sn-container span, .model-container span {
    width: 70px;
    height: 40px;
    line-height: 40px;
    text-align: right;
    padding-right: 8px;
  }
  h4 {
    margin-bottom: 10px;
  }
  .green-btn {
    border-radius: 20px;
    border: none;
    background-color: #58D56D;
  }
  .search-input .el-input__inner, .el-input--prefix .el-input__inner {
    border-radius: 20px!important;
  }
  /* .search-container {
      padding-right: 50px;
  } */
  .upload-green-btn {
    padding: 10px 20px;
  }
  .add-button {
    padding: 14px 27px;
  }
  .title-container {
    padding-left: 0px!important;
  }
  .required-add {
    color: red;
    font-size: 20px;
    font-weight: 600;
    position: absolute;
    top: 8px;
    width: 10px!important;
  }
  .required-sn {
    left: 22px;
  }
  .required-model {
    left: 2px;
  }
  .red-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    position: relative;
    top: 3px;
    background-color: #d82005;
    border: 3px solid #f5c7c0;
  }
  .green-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    position: relative;
    top: 3px;
    background-color: #22ba78;
    border: 3px solid #c6eedc;
  }
  .search-container {
    height: 42px;
  }
  .rearchSelect {
    top: -8px;
    width: 150px;
  }
  .reachInput {
    top: -8px;
    padding-left: 150px;
  }
  .map-container {
    display: flex;
  }
  .map {
    margin-right: 40px;
    height: 42px;
    color: #1acad9;
    border: 1px solid #1acad9;
  }
  .hrefStyle {
    color: #3ba2ec;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/TerminalList.vue